import React from 'react';
import { Tooltip } from 'antd';

interface PropsTooltips {
  title: string | null;
  children: React.ReactNode;
}

const Tooltips: React.FC<PropsTooltips> = ({ title, children }) => {
  return (
    title ? (
      <Tooltip title={title}
               placement="topRight"
               arrow={false}>
        {children}
      </Tooltip>
    ) : (
      <>{children}</>
    )
  );
};

export default Tooltips;
